<script setup lang="ts">
  defineOptions({
    name: 'ClientportalLoginModal',
  })

  import { computed } from 'vue'

  import { useI18n } from 'vue-i18n'

  import CommonLoginModal from '@common/auth-layer/components/LoginModal.vue'
  import { useAuth } from '@common/auth-layer/composables/useAuth'
  import { useLocation } from '@common/location-layer/composables/useLocation'

  import { resolvePortalLogo } from '@clientportal/auth-layer/utils/branding-assets'

  const { t } = useI18n()
  const { store: locationStore } = useLocation()
  const { handleRedirectAfterLogin } = useAuth()
  const brandLogo = computed(() => resolvePortalLogo(locationStore.branding))
  const brandName = computed(() => {
    return locationStore.branding?.portalBannerText || t('auth.branding.defaultPortalName')
  })

  const resolvedIsSsoDisabled = computed(() => locationStore.locationData?.isSSODisabled === true)
  const onLoginSuccess = async () => {
    await handleRedirectAfterLogin()
  }
</script>

<template>
  <CommonLoginModal
    :brand-logo="brandLogo"
    :brand-name="brandName"
    :is-sso-disabled="resolvedIsSsoDisabled"
    @login-success="onLoginSuccess"
  />
</template>
